<template>
    <div v-if="pagination.totalItems > 10" class="pagination-container">
  <div class="pagination-container">
    <div class="pagination-wrapper">
      <!-- First Page Button -->
      <button
        @click="changePage(1)"
        :disabled="pagination.currentPage === 1"
        class="page-button first-last"
        :aria-label="t('pagination.first_page')"
      >
        <i class="fas fa-angle-double-right"></i>
      </button>

      <!-- Previous Button -->
      <button
        @click="changePage(pagination.currentPage - 1)"
        :disabled="pagination.currentPage === 1"
        class="page-button prev-next"
        :aria-label="t('pagination.previous')"
      >
        <i class="fas fa-angle-right"></i>
      </button>

      <div class="page-numbers">
        <button
          v-for="page in visiblePages"
          :key="page"
          @click="changePage(page)"
          :class="{ active: page === pagination.currentPage }"
          class="page-button number"
        >
          {{ page }}
        </button>
      </div>

      <button
        @click="changePage(pagination.currentPage + 1)"
        :disabled="pagination.currentPage === pagination.totalPages"
        class="page-button prev-next"
        :aria-label="t('pagination.next')"
      >
        <i class="fas fa-angle-left"></i>
      </button>

      <button
        @click="changePage(pagination.totalPages)"
        :disabled="pagination.currentPage === pagination.totalPages"
        class="page-button first-last"
        :aria-label="t('pagination.last_page')"
      >
        <i class="fas fa-angle-double-left"></i>
      </button>
    </div>

    <div class="items-count">
      {{ t('pagination.displaying') }} {{ pagination.from }} - {{ pagination.to }} {{ t('pagination.of') }} {{ pagination.totalItems }}
    </div>
  </div>
  </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps({
  pagination: {
    type: Object,
    required: true
  }
});

const emit = defineEmits(['page-changed']);

const visiblePages = computed(() => {
  const pages = [];
  const current = props.pagination.currentPage;
  const total = props.pagination.totalPages;
  const range = 2; 
  
  for (let i = Math.max(1, current - range); i <= Math.min(total, current + range); i++) {
    pages.push(i);
  }
  return pages;
});

const changePage = (page) => {
  if (page >= 1 && page <= props.pagination.totalPages) {
    emit('page-changed', page);
  }
};
</script>

<style scoped>
</style>